// frontend/src/modules/funcionarios/components/FuncionarioDetalhes.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaEdit, FaPlus, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

function FuncionarioDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [funcionario, setFuncionario] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [mostrarBeneficio, setMostrarBeneficio] = useState(false);
  const [mostrarDesconto, setMostrarDesconto] = useState(false);
  const [beneficioForm, setBeneficioForm] = useState({
    tipo: '',
    descricao: '',
    valor_total: '',
    quantidade: 1,
    valor_unitario: '',
    data_inicio: new Date().toISOString().split('T')[0],
    data_fim: '',
    descontar_folha: false,
    observacao: ''
  });
  const [descontoForm, setDescontoForm] = useState({
    tipo: '',
    descricao: '',
    valor: '',
    quantidade: 1,
    valor_unitario: '',
    data_desconto: new Date().toISOString().split('T')[0],
    mes_referencia: '',
    observacao: ''
  });

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const token = localStorage.getItem('token');

  const fetchFuncionario = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/funcionarios/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar funcionário');
      const data = await response.json();
      setFuncionario(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFuncionario();
  }, [id]);

  const handleBeneficioSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`/api/funcionarios/${id}/beneficios`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...beneficioForm,
          valor_total: parseFloat(beneficioForm.valor_total) || 0,
          valor_unitario: parseFloat(beneficioForm.valor_unitario) || 0,
          quantidade: parseInt(beneficioForm.quantidade) || 1
        })
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Erro ao criar benefício');
      }
      
      setSuccess('✅ Benefício adicionado!');
      setMostrarBeneficio(false);
      setBeneficioForm({
        tipo: '',
        descricao: '',
        valor_total: '',
        quantidade: 1,
        valor_unitario: '',
        data_inicio: new Date().toISOString().split('T')[0],
        data_fim: '',
        descontar_folha: false,
        observacao: ''
      });
      fetchFuncionario();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDescontoSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`/api/funcionarios/${id}/descontos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...descontoForm,
          valor: parseFloat(descontoForm.valor) || 0,
          valor_unitario: parseFloat(descontoForm.valor_unitario) || 0,
          quantidade: parseInt(descontoForm.quantidade) || 1
        })
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Erro ao criar desconto');
      }
      
      setSuccess('✅ Desconto adicionado!');
      setMostrarDesconto(false);
      setDescontoForm({
        tipo: '',
        descricao: '',
        valor: '',
        quantidade: 1,
        valor_unitario: '',
        data_desconto: new Date().toISOString().split('T')[0],
        mes_referencia: '',
        observacao: ''
      });
      fetchFuncionario();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBeneficio = async (beneficioId) => {
    if (!window.confirm('Remover este benefício?')) return;
    try {
      const response = await fetch(`/api/beneficios/${beneficioId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao remover');
      fetchFuncionario();
      setSuccess('✅ Benefício removido!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDeleteDesconto = async (descontoId) => {
    if (!window.confirm('Remover este desconto?')) return;
    try {
      const response = await fetch(`/api/descontos/${descontoId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao remover');
      fetchFuncionario();
      setSuccess('✅ Desconto removido!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  const formatCurrency = (value) => {
    if (!value) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;
  if (error) return <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>❌ {error}</div>;
  if (!funcionario) return <div style={{ textAlign: 'center', padding: '50px' }}>Funcionário não encontrado</div>;

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'flex-start' : 'center', 
        marginBottom: '20px',
        gap: '10px'
      }}>
        <div>
          <button onClick={() => navigate('/funcionarios')} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', fontSize: isMobile ? '14px' : '16px', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <FaArrowLeft /> Voltar
          </button>
          <h2 style={{ margin: '5px 0 0 0', fontSize: isMobile ? '20px' : '28px' }}>👤 {funcionario.nome_completo}</h2>
          <p style={{ color: '#6c757d', margin: '0', fontSize: isMobile ? '13px' : '14px' }}>
            {funcionario.cargo || 'Sem cargo'} • {funcionario.ativo ? '✅ Ativo' : '❌ Inativo'}
          </p>
        </div>
        <button 
          onClick={() => navigate(`/funcionarios/editar/${id}`)} 
          style={{ 
            padding: isMobile ? '8px 16px' : '10px 20px', 
            backgroundColor: '#ffc107', 
            color: '#212529', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            justifyContent: 'center',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <FaEdit /> Editar
        </button>
      </div>

      {/* Mensagens */}
      {success && <div style={{ backgroundColor: '#e8f5e9', padding: '10px', borderRadius: '4px', color: '#2e7d32', marginBottom: '15px', fontSize: isMobile ? '13px' : '14px' }}>✅ {success}</div>}
      {error && <div style={{ backgroundColor: '#ffebee', padding: '10px', borderRadius: '4px', color: '#c62828', marginBottom: '15px', fontSize: isMobile ? '13px' : '14px' }}>❌ {error}</div>}

      {/* Dados Pessoais e Trabalhistas */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
        gap: isMobile ? '15px' : '20px' 
      }}>
        <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>📋 Dados Pessoais</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px 15px' }}>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>CPF:</strong> {funcionario.cpf || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>RG:</strong> {funcionario.rg || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Nascimento:</strong> {formatDate(funcionario.data_nascimento)}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Telefone:</strong> {funcionario.telefone || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Email:</strong> {funcionario.email || '-'}</p>
            <p style={{ gridColumn: '1 / -1', margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Endereço:</strong> {funcionario.endereco || '-'} {funcionario.numero ? `, ${funcionario.numero}` : ''}</p>
            <p style={{ gridColumn: '1 / -1', margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Cidade/UF:</strong> {funcionario.cidade || '-'} {funcionario.estado ? `- ${funcionario.estado}` : ''}</p>
          </div>
        </div>

        <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>💼 Dados Trabalhistas</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px 15px' }}>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Cargo:</strong> {funcionario.cargo || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Salário:</strong> {formatCurrency(funcionario.salario)}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Admissão:</strong> {formatDate(funcionario.data_admissao)}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>CTPS:</strong> {funcionario.carteira_trabalho || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>PIS/PASEP:</strong> {funcionario.pis_pasep || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Banco:</strong> {funcionario.banco || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Agência:</strong> {funcionario.agencia || '-'}</p>
            <p style={{ margin: '5px 0', fontSize: isMobile ? '13px' : '14px' }}><strong>Conta:</strong> {funcionario.conta || '-'}</p>
          </div>
        </div>
      </div>

      {/* Benefícios */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginTop: '20px' }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between', 
          alignItems: isMobile ? 'stretch' : 'center',
          gap: isMobile ? '10px' : '0'
        }}>
          <h3 style={{ fontSize: isMobile ? '16px' : '18px', margin: 0 }}>🎁 Benefícios</h3>
          <button 
            onClick={() => setMostrarBeneficio(!mostrarBeneficio)} 
            style={{ 
              padding: isMobile ? '8px 16px' : '8px 16px', 
              backgroundColor: '#28a745', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              justifyContent: 'center',
              width: isMobile ? '100%' : 'auto'
            }}
          >
            {mostrarBeneficio ? <FaTimes /> : <FaPlus />} {mostrarBeneficio ? 'Cancelar' : 'Adicionar Benefício'}
          </button>
        </div>

        {mostrarBeneficio && (
          <form onSubmit={handleBeneficioSubmit} style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', marginTop: '10px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '10px' }}>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Tipo</label>
                <select 
                  name="tipo" 
                  value={beneficioForm.tipo} 
                  onChange={(e) => setBeneficioForm({...beneficioForm, tipo: e.target.value})} 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                >
                  <option value="">Selecione...</option>
                  <option value="VT">Vale Transporte</option>
                  <option value="VA">Vale Alimentação</option>
                  <option value="VR">Vale Refeição</option>
                  <option value="PLANO_SAUDE">Plano de Saúde</option>
                  <option value="PLANO_ODONTO">Plano Odontológico</option>
                  <option value="SEGURO_VIDA">Seguro de Vida</option>
                  <option value="OUTRO">Outro</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Descrição</label>
                <input 
                  name="descricao" 
                  value={beneficioForm.descricao} 
                  onChange={(e) => setBeneficioForm({...beneficioForm, descricao: e.target.value})} 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }} 
                />
              </div>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Valor Total (R$)</label>
                <input 
                  name="valor_total" 
                  value={beneficioForm.valor_total} 
                  onChange={(e) => setBeneficioForm({...beneficioForm, valor_total: e.target.value})} 
                  type="number" 
                  step="0.01" 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }} 
                />
              </div>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Data Início</label>
                <input 
                  name="data_inicio" 
                  value={beneficioForm.data_inicio} 
                  onChange={(e) => setBeneficioForm({...beneficioForm, data_inicio: e.target.value})} 
                  type="date" 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }} 
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Descontar na Folha</label>
                <input 
                  name="descontar_folha" 
                  checked={beneficioForm.descontar_folha} 
                  onChange={(e) => setBeneficioForm({...beneficioForm, descontar_folha: e.target.checked})} 
                  type="checkbox" 
                  style={{ width: '20px', height: '20px' }} 
                />
              </div>
            </div>
            <button 
              type="submit" 
              style={{ 
                marginTop: '10px', 
                padding: isMobile ? '8px 20px' : '8px 20px', 
                backgroundColor: '#007bff', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px', 
                cursor: 'pointer',
                fontSize: isMobile ? '13px' : '14px',
                width: isMobile ? '100%' : 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                justifyContent: 'center'
              }}
            >
              <FaSave /> Salvar Benefício
            </button>
          </form>
        )}

        <div style={{ overflowX: 'auto', marginTop: '10px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ padding: '8px', textAlign: 'left', fontSize: isMobile ? '12px' : '13px' }}>Tipo</th>
                <th style={{ padding: '8px', textAlign: 'left', fontSize: isMobile ? '12px' : '13px' }}>Descrição</th>
                <th style={{ padding: '8px', textAlign: 'right', fontSize: isMobile ? '12px' : '13px' }}>Valor</th>
                <th style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>Início</th>
                <th style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {funcionario.beneficios?.length === 0 ? (
                <tr><td colSpan="5" style={{ textAlign: 'center', padding: '10px', fontSize: isMobile ? '13px' : '14px' }}>📭 Nenhum benefício cadastrado</td></tr>
              ) : (
                funcionario.beneficios?.map(b => (
                  <tr key={b.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                    <td style={{ padding: '8px', fontSize: isMobile ? '12px' : '13px' }}>{b.tipo}</td>
                    <td style={{ padding: '8px', fontSize: isMobile ? '12px' : '13px' }}>{b.descricao}</td>
                    <td style={{ padding: '8px', textAlign: 'right', fontSize: isMobile ? '12px' : '13px' }}>{formatCurrency(b.valor_total)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>{formatDate(b.data_inicio)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>
                      <button onClick={() => handleDeleteBeneficio(b.id)} style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}>
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Descontos */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginTop: '20px' }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between', 
          alignItems: isMobile ? 'stretch' : 'center',
          gap: isMobile ? '10px' : '0'
        }}>
          <h3 style={{ fontSize: isMobile ? '16px' : '18px', margin: 0 }}>💸 Descontos</h3>
          <button 
            onClick={() => setMostrarDesconto(!mostrarDesconto)} 
            style={{ 
              padding: isMobile ? '8px 16px' : '8px 16px', 
              backgroundColor: '#dc3545', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              justifyContent: 'center',
              width: isMobile ? '100%' : 'auto'
            }}
          >
            {mostrarDesconto ? <FaTimes /> : <FaPlus />} {mostrarDesconto ? 'Cancelar' : 'Adicionar Desconto'}
          </button>
        </div>

        {mostrarDesconto && (
          <form onSubmit={handleDescontoSubmit} style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', marginTop: '10px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '10px' }}>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Tipo</label>
                <select 
                  name="tipo" 
                  value={descontoForm.tipo} 
                  onChange={(e) => setDescontoForm({...descontoForm, tipo: e.target.value})} 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                >
                  <option value="">Selecione...</option>
                  <option value="FALTA">Falta</option>
                  <option value="ATRASO">Atraso</option>
                  <option value="ADIANTAMENTO">Adiantamento</option>
                  <option value="EMPRESTIMO">Empréstimo</option>
                  <option value="OUTRO">Outro</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Descrição</label>
                <input 
                  name="descricao" 
                  value={descontoForm.descricao} 
                  onChange={(e) => setDescontoForm({...descontoForm, descricao: e.target.value})} 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }} 
                />
              </div>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Valor (R$)</label>
                <input 
                  name="valor" 
                  value={descontoForm.valor} 
                  onChange={(e) => setDescontoForm({...descontoForm, valor: e.target.value})} 
                  type="number" 
                  step="0.01" 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }} 
                />
              </div>
              <div>
                <label style={{ fontSize: isMobile ? '12px' : '13px' }}>Data do Desconto</label>
                <input 
                  name="data_desconto" 
                  value={descontoForm.data_desconto} 
                  onChange={(e) => setDescontoForm({...descontoForm, data_desconto: e.target.value})} 
                  type="date" 
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }} 
                />
              </div>
            </div>
            <button 
              type="submit" 
              style={{ 
                marginTop: '10px', 
                padding: isMobile ? '8px 20px' : '8px 20px', 
                backgroundColor: '#dc3545', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px', 
                cursor: 'pointer',
                fontSize: isMobile ? '13px' : '14px',
                width: isMobile ? '100%' : 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                justifyContent: 'center'
              }}
            >
              <FaSave /> Salvar Desconto
            </button>
          </form>
        )}

        <div style={{ overflowX: 'auto', marginTop: '10px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ padding: '8px', textAlign: 'left', fontSize: isMobile ? '12px' : '13px' }}>Tipo</th>
                <th style={{ padding: '8px', textAlign: 'left', fontSize: isMobile ? '12px' : '13px' }}>Descrição</th>
                <th style={{ padding: '8px', textAlign: 'right', fontSize: isMobile ? '12px' : '13px' }}>Valor</th>
                <th style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>Data</th>
                <th style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {funcionario.descontos?.length === 0 ? (
                <tr><td colSpan="5" style={{ textAlign: 'center', padding: '10px', fontSize: isMobile ? '13px' : '14px' }}>📭 Nenhum desconto cadastrado</td></tr>
              ) : (
                funcionario.descontos?.map(d => (
                  <tr key={d.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                    <td style={{ padding: '8px', fontSize: isMobile ? '12px' : '13px' }}>{d.tipo}</td>
                    <td style={{ padding: '8px', fontSize: isMobile ? '12px' : '13px' }}>{d.descricao}</td>
                    <td style={{ padding: '8px', textAlign: 'right', fontSize: isMobile ? '12px' : '13px' }}>{formatCurrency(d.valor)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>{formatDate(d.data_desconto)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontSize: isMobile ? '12px' : '13px' }}>
                      <button onClick={() => handleDeleteDesconto(d.id)} style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}>
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default FuncionarioDetalhes;